import {Helpers} from "//www.greenwellfarms.com/cdn/shop/t/53/assets/helpers.js?v=181223628927866135401733338766";
import {Notification} from "//www.greenwellfarms.com/cdn/shop/t/53/assets/notification.js?v=176905153872812366211733338986";

class Base{

    constructor(){
        this.hooks = {};
        this.params = {};
        this.helpers = Helpers;
        if("undefined" === typeof window.notification){
            window.notification = new Notification();
            window.notification.init();
        }
    }

    empty_object(the_object){ 
        return null === the_object || Object.keys(the_object).length === 0; 
    }

    get_data(){return this.params;}
    get_dom(){return this.get("el") || null;}
    get_breakpoints(){ return Helpers.break_points;}

    rm(_key){
        if("undefined" === typeof this.params[_key]) return null;
        delete this.params[_key];
        return this;
    }

    set(_key, _value){this.params[_key] = _value; return this;}

    get(_key){
        if("undefined" === typeof this.params[_key]) return null;
        return this.params[_key];
    }

    load_style(key, path, media){

        if("undefined" === typeof path || null === path) return this;
        if("undefined" === typeof media || null === media) media = "screen";

        if(document.querySelector(`link#${key}`) !== null) return this;

        let the_style = document.createElement("link");
        the_style.id = key;
        the_style.href = path;
        the_style.setAttribute("rel", "stylesheet");
        document.head.append(the_style);

        return this;

    } // loading style

    load_script(key, path, type){

        if("undefined" === typeof path || null === path) return this;
        if("undefined" === typeof type || null === type) type = "async";

        if(document.querySelector(`script#${key}`) !== null) return this;

        let the_script = document.createElement("script");
        the_script.id = key;
        the_script.src = path;
        the_script.setAttribute(type, "");

        document.body.append(the_script);

        return this;

    } // loading style

    get_api_uri(){
        return ``;
    }

    add_hooks(_key, _func){

        if("function" !== typeof _func) return this;
        if("undefined" === typeof this.hooks[_key]) this.hooks[_key] = [];
        this.hooks[_key].push(_func);
        return this;

    }// end of function add hooks

    run_hooks(_key, _the_data = null){
        if("undefined" === typeof this.hooks[_key]) return this;
        if(this.hooks[_key].length === 0) return this;

        this.hooks[_key].forEach((_single_function) => {
            if("function" === typeof _single_function) {
                _single_function(_the_data);
            }
        });

        return this;
    } // end of running hooks


    add_global_hooks(_key, _func){

        if("function" !== typeof _func) return this;
        if("undefined" === typeof window._global_hooks) window._global_hooks = {};
        if("undefined" === typeof window._global_hooks[_key]) window._global_hooks[_key] = [];
        window._global_hooks[_key].push(_func);
        return this;

    }// end of function add hooks

    run_global_hooks(_key, _the_data = null){
        if("undefined" === typeof window._global_hooks[_key]) return this;
        if(window._global_hooks[_key].length === 0) return this;

        window._global_hooks[_key].forEach((_single_function) => {
            if("function" === typeof _single_function) {
                _single_function(_the_data);
            }
        });

        return this;
    } // end of running hooks

    set_status(the_value){ this.get("el").setAttribute(`data-status`, the_value); return this; }

    success(message){
        if("undefined" !== typeof window.notification){
            window.notification.success(message); 
        }
        return this;
    }

    info(message){

        if("undefined" !== typeof window.notification){
            window.notification.info(message); 
        }
        return this;
    }

    failed(error){
        
        if("undefined" !== typeof window.notification){
            window.notification.error(error); 
        }

        return this;
    }

    do_waiting(the_container = null){
        if(null === the_container){
            document.body.setAttribute("data-status", Helpers.statuses.waiting);
        }else{

            if("undefined"  === typeof the_container.dataset.statusReady || null === the_container.dataset.statusReady){
                this.prep_container_for_status_ready(the_container);
            }
            the_container.setAttribute("data-status", Helpers.statuses.waiting);
        }
        return this;
    } // do waiting

    done_waiting(the_container = null){
        if(null === the_container){
            document.body.setAttribute("data-status", Helpers.statuses.done_waiting);
        }else{
            if("undefined"  === typeof the_container.dataset.statusReady || null === the_container.dataset.statusReady){
                this.prep_container_for_status_ready(the_container);
            }
            the_container.setAttribute("data-status", Helpers.statuses.done_waiting);

        }
        return this;
    } // done waiting
    
    do_clear(the_container, __callback){

        if("undefined" === typeof the_container) return this;
        if(null === the_container || the_container.length === 0) return this;
        if(the_container.childNodes.length > 0){
            the_container.childNodes[0].remove();
            return this.do_clear(the_container, __callback);
        }
       
        if("function" === typeof __callback){
            __callback();
        }

        return this;
    } // end of clearing 



    reset_form(the_form = null){
        if("undefined" === typeof the_form || null === the_form){
            the_form = this.get_container();
        }

        var the_inputs = the_form.querySelectorAll("input,select,textarea");

        if(the_inputs.length > 0){
            the_inputs.forEach((input) =>  {

                switch(input.type){
                    case "hidden":break;
                    default: 
                        input.value = input.dataset.currentValue || "";
                }
            });
        }

        return this;

    } // 

    // validate the form
    validate(the_form = null){

        if(null === the_form) the_form = this.get("el");

        var 
            the_inputs = the_form.querySelectorAll("[required]"), 
            has_error = false, 
            input_wrapper = null;
            the_inputs.forEach((input) => {
                input_wrapper = the_form.querySelector("#df_" + input.name);
                if(!input.checkValidity()){
                    if(null !== input_wrapper){
                        input_wrapper.classList.add(Helpers.classes.has_error);
                    }
                    has_error = true;
                }else{
                    if(null !== input_wrapper){
                        input_wrapper.classList.remove(Helpers.classes.has_error);
                    }
                }

            });

        return !has_error;

    } // end of function to validate form


    collect_data(the_form = null) {

        if("undefined" === typeof the_form || null === the_form) the_form = this.get("el");
        var
            the_inputs = the_form.querySelectorAll("input,select,textarea"), 
            the_data = {};


        if(the_inputs.length > 0){

            the_inputs.forEach((input) => {

                if(input.name.length > 0){

                    switch(input.tagName){

                        case "SELECT":
                        case "TEXTAREA":

                            the_data[input.name] = input.value;
                            break;

                        case "INPUT":

                            switch(input.type.toLowerCase()){

                                case "checkbox": /// will need to check if []
                                case "radio":

                                    if(input.checked){
                                        the_data[input.name] = input.value;
                                    }

                                    break;

                                case "text":
                                case "email":
                                case "tel":
                                case "number":
                                case "password":
                                    the_data[input.name] = input.value;
                                    break;

                            }//

                        break;
                    }
                }

            });

        } //
    
        return the_data;

    }// end of function to collect data


    get_container(target = null, key = null){

        if("undefined" === typeof target  || null === target) target = this.get("el");

        if(null === key) key = "js-container";
        var container = target.querySelector(`.${key},[data-type='${key}']`);

        if(null === container) return target;
        return container;

    } // end of function get container



    prep_container_for_status_ready(the_container){

        var status_overlay = document.createElement("div");
        status_overlay.classList.add("status-overlay-wrapper");
        status_overlay.innerHTML = `
            <div class='status-overlay-inner'>
                <div class='s-content'>
                    <div class='s-content-inner'>
                        <svg id="Capa_1" enable-background="new 0 0 497 497" height="512" viewBox="0 0 497 497" width="512" xmlns="http://www.w3.org/2000/svg"><g><circle cx="98" cy="376" fill="#909ba6" r="53"></circle><circle cx="439" cy="336" fill="#c8d2dc" r="46"></circle><circle cx="397" cy="112" fill="#e9edf1" r="38"></circle><ellipse cx="56.245" cy="244.754" fill="#7e8b96" rx="56.245" ry="54.874"></ellipse><ellipse cx="217.821" cy="447.175" fill="#a2abb8" rx="51.132" ry="49.825"></ellipse><ellipse cx="349.229" cy="427.873" fill="#b9c3cd" rx="48.575" ry="47.297"></ellipse><ellipse cx="117.092" cy="114.794" fill="#5f6c75" rx="58.801" ry="57.397"></ellipse><ellipse cx="453.538" cy="216.477" fill="#dce6eb" rx="43.462" ry="42.656"></ellipse><circle cx="263" cy="62" fill="#4e5a61" r="62"></circle></g></svg>
                    </div>
                </div>
            </div>
        `;
        the_container.append(status_overlay);
        the_container.setAttribute("data-status-ready", "1");
        the_container.classList.add("status-overlay");

        return this;
    } // 

    save_key(key, value){ localStorage.setItem(key, value); return this; }
    get_key(key){ return localStorage.getItem(key);}
    remove_key(key){ localStorage.removeItem(key) ;}
    clean_tags(the_text){return the_text.replace(/(<([^>]+)>)/gi, '');}

    show(){ this.get_dom().setAttribute("data-show", "1"); return this; }
    hide(){ this.get_dom().setAttribute("data-show", "-1"); return this; }

    scale_image(the_path, size){

        if("undefined" === typeof the_path  || the_path === null) return this;
        return the_path.replace(/(\.jpg|\.png|\.jpeg|\.webp)/gi, `_${size}$1`);

    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    fetchConfig(type = 'json') {
        return {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
        };
      }
      getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }

    prep_selector(selector, options){

        if("undefined" === typeof selector || null === selector){
            selector = document.createElement(options.tag || "div");
            selector.innerHTML = `<${options.tag || "div"} class="wrapper-inner" data-type="js-container"></${options.tag || "div"}>`;
        }else{
            let container = selector.querySelector("[data-type='js-container']");

            if(null === container && selector.childNodes.length === 0){
                selector.innerHTML = `<${options.tag || "div"} class="wrapper-inner" data-type="js-container"></${options.tag || "div"}>`;
            }
        }
        if("undefined" !== typeof options.classes && options.classes.length > 0){
            options.classes.forEach(c => selector.classList.add(c));
        }
        return selector;
    }

    to_money(value){
        let formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        return formatter.format(value); 
    } // 

    /**
     * params:
     * cents        : (int) values in cents
     * format       : (string) one of the following options
     *                  amount
     *                  amount_no_decimals
     *                  amount_with_comma_separator
     *                  amount_no_decimals_with_comma_separator
     * 
     * return (string)
     * */
    format_money(cents, format) {

        if (typeof cents == 'string') { cents = cents.replace('.',''); }

        let value = '',
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
             formatString = (format || this.money_format);

        function defaultOption(opt, def) {
             return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal     = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            var parts     = number.split('.'),
                    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                    cents     = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }
        return formatWithDelimiters(cents, 2, '.', ',');
    };


    format_phone(the_string) { 
        let cleaned = ('' + the_string).replace(/\D/g, ''),
            match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (match) return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        
        return null;
    }

}


export{Base};
